import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { Header } from '../Header/Header';
import { Footer } from '../Footer';
import { Ad } from '../responsive/atoms/Ad';
import { CookieFooter } from './components/CookieFooter';
import { facePaint } from '../../domain/theme/utils/facePaint';
import { DrupalEditContent } from '../Header/components/DrupalEditContent';

const getStyles = content => ({
  // This must be greater that 101 because of:
  //  * a) vertical slideshow galleries using z-index from 0 to 100
  //  * b) header banner using z-index 101
  headersContainer: css`
    display: ${content.hideHeader ? 'none' : null};
    z-index: 296;
    position: relative;
  `,
  // Add a z-index of 101 to avoid Vertical Slideshow Gallery to cover this ad.
  // Use 101 because a vertical slideshow can have up to 100 items.
  headerAd: css`
    position: relative;
    z-index: 101;
  `,
  contentVisibilityFooter: css`
    display: ${content.hideFooter ? 'none' : null};
    content-visibility: auto;
    clear: both;
    ${facePaint({
      'contain-intrinsic-size': ['0 1445px', '0 537px', '0 487px', '0 487px']
    })};
  `,
  adBanner: css`
    background-color: #fff;
    padding: 10px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    text-align: center;
    clear: both;
  `
});
export const Layout = ({ content, children }) => {
  const styles = getStyles(content);
  return (
    <>
      <div className="page-content">
        <div className="content-cntr">
          {/* Keep headers-container, because it's used by blank templates to hide it */}
          <div className="headers-container" css={styles.headersContainer}>
            <Header content={content} />
          </div>
          <div className="layout-cntr">
            <div id="visibility" />
            {content.noAds || content.hideHeaderAd ? null : (
              <div css={styles.headerAd}>
                <div css={styles.adBanner}>
                  <Ad id="header" content={content} />
                </div>
              </div>
            )}

            <main role="main" id="main-content">
              <div id="layout-content">
                <div>
                  <div id="block-nationalgeographic-content">
                    {children}
                    <div
                      id="block-nationalgeographicfooterblock"
                      css={styles.contentVisibilityFooter}
                    >
                      <Footer />
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
          <CookieFooter />
          {content.id && <DrupalEditContent id={content.id} />}
        </div>
      </div>
      <div
        id="ng-metadata"
        // eslint-disable-next-line
        dangerouslySetInnerHTML={{
          __html: `<!-- source-file: ${content.sourceFile} | content-type: ${content.bundle} -->`
        }}
      />
    </>
  );
};

Layout.defaultProps = {
  content: {}
};

Layout.propTypes = {
  content: PropTypes.objectOf(PropTypes.any),
  children: PropTypes.node.isRequired
};
